export const defaultPreferredTime = "09:00";
export const defaultIntervalDays = undefined;
export const defaultMaxReminders = undefined;
